import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';


document.addEventListener('DOMContentLoaded', function() {
    // Controleer of het element bestaat voordat we Swiper initialiseren
    const swiperElement = document.querySelector('.logos-swiper');
    if (!swiperElement) {
       
        return;
    }

    
    const logoSwiper = new Swiper('.logos-swiper', {
        modules: [Autoplay],
        direction: 'horizontal',
        slidesPerView: 2,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 2400,
            disableOnInteraction: false,
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3
            },
                
            1024: {
                slidesPerView: 4
                
            },
            1440: {
                slidesPerView: 5
            },
        },
        // Zorg ervoor dat afbeeldingen correct worden geladen
        on: {
            init: function() {
                console.log('Swiper geïnitialiseerd');
                this.update();
            },
            imagesReady: function() {
                console.log('Afbeeldingen geladen, Swiper bijgewerkt');
                this.update();
            }
        }
    });
    
    console.log('Swiper instantie gemaakt:', logoSwiper);
});
